import type { IClient } from "@/models/clients";

export enum ConsentType {
  ApplicationDataAccuracy = "application_data_accuracy",
  ThirdPartyDataSharing = "third_party_data_sharing",
  CreditCheck = "credit_check",
  Communication = "communication",
}

export type ConsentTypes = Record<ConsentType, string>;

export interface Consent {
  id: string;
  type: ConsentType | null;
  message: string | null;
  is_required: boolean;
}

export interface ConsentTemplateContent {
  consents: Consent[];
  hide_text_in_scroll_area: boolean;
  message: string | null;
  version: string;
}

export interface PayloadConsentTemplate {
  content?: ConsentTemplateContent;
  force_default?: boolean;
  is_default: boolean;
  name: ConsentTemplate["name"];
}

export interface ConsentTemplateErrors {
  consentMessages: ({ type?: string; message?: string } | null)[];
  validated: boolean;
  name?: string;
  contentMessage?: string;
  consentRequired?: string;
}

export interface ConsentTemplate {
  client_id?: IClient["id"];
  content: ConsentTemplateContent;
  id: string;
  is_default: boolean;
  is_lendflow_template: boolean;
  name: string | null;
}

export interface SimpleConsentTemplate {
  client_id: IClient["id"];
  is_default: boolean;
  is_lendflow_template: boolean;
  id: string;
  message: string;
  name: string;
}

export type ConflictingConsentTemplate =
  | Pick<SimpleConsentTemplate, "id" | "name">
  | Pick<ConsentTemplate, "id" | "name">;
